import script from "./SuccessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessModal.vue?vue&type=script&setup=true&lang=ts"

import "./SuccessModal.vue?vue&type=style&index=0&id=cbfe8f50&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbfe8f50"]])

export default __exports__